import { NO_VALUE } from "consts";

/** Number with an explicit sign, e.g. `+5`, `-5`, `0`. */
export const formatSigned = (value: number): string => (value > 0 ? `+${value}` : String(value));

/** Signed percent, e.g. `+5%`, `-5%`, `0%`. */
export const formatSignedPercent = (value: number): string => `${formatSigned(value)}%`;

/** Whole signed percent, rounded away from zero: `Math.round` is half-up and shows -1.5% as -1%. */
export const formatWholeSignedPercent = (value: number | null): string => {
  if (value === null) return NO_VALUE;
  return formatSignedPercent(Math.sign(value) * Math.round(Math.abs(value)));
};

/** Text colour class for a signed table value: zero counts as positive. */
export const valueToneClassName = (value: number): string =>
  value >= 0 ? "outcome-comparison-table-change-positive" : "outcome-comparison-table-change-negative";

/** Rounded change against the baseline as the table shows it inline: tone class, trend icon and "+ 5%" style label. */
export const inlinePctDisplay = (pct: number) => {
  const rounded = Math.round(pct);
  return {
    className:
      rounded === 0
        ? "outcome-comparison-table-change--reference-delta"
        : rounded > 0
        ? "outcome-comparison-table-change-positive"
        : "outcome-comparison-table-change-negative",
    icon: rounded >= 0 ? "tabler/trending-up" : "tabler/trending-down",
    label: rounded > 0 ? `+ ${rounded}%` : rounded < 0 ? `- ${Math.abs(rounded)}%` : "+ 0%",
  };
};
